import { FETCH_DASHBOARD_SUMMARY } from '../constants/actionTypes';

const initialState = {
  summary: null,      // { totalBatches, expiring90, expiring30, expiring7, expiring1, expired, activeAlerts, newAlertsToday, lastBatchAddedAt }
  lastUpdated: null,  // timestamp in ms
};

const dashboard = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_SUMMARY:
      return {
        ...state,
        summary: action.payload || null,
        lastUpdated: Date.now(),
      };

    default:
      return state;
  }
}

export default dashboard;
